/**
 * Single source of truth for environment-dependent config. Prefers
 * window.__RUNTIME_CONFIG__ (injected by server.js's /config.js at runtime
 * in production) and falls back to Vite's build-time import.meta.env
 * (used by `vite dev` locally, where server.js isn't running).
 */
const runtime = typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined;

function pick(runtimeKey, viteKey, fallback = "") {
  return runtime?.[runtimeKey] || import.meta.env[viteKey] || fallback;
}

export const config = {
  apiBaseUrl: pick("API_BASE_URL", "VITE_API_BASE_URL", "http://localhost:7071/api"),
  b2cClientId: pick("B2C_CLIENT_ID", "VITE_B2C_CLIENT_ID"),
  b2cAuthority: pick("B2C_AUTHORITY", "VITE_B2C_AUTHORITY"),
  b2cKnownAuthority: pick("B2C_KNOWN_AUTHORITY", "VITE_B2C_KNOWN_AUTHORITY"),
  b2cMfaAuthority: pick("B2C_MFA_AUTHORITY", "VITE_B2C_MFA_AUTHORITY"),
  b2cRedirectUri: pick("B2C_REDIRECT_URI", "VITE_B2C_REDIRECT_URI", window?.location?.origin),
  googleMapsApiKey: pick("GOOGLE_MAPS_API_KEY", "VITE_GOOGLE_MAPS_API_KEY"),
  supportedLanguages: pick("SUPPORTED_LANGUAGES", "VITE_SUPPORTED_LANGUAGES", "en,es,fr").split(","),
};
